import PropTypes from 'prop-types';
import React, {Component} from 'react';

class CartPropertySelection extends Component {

    static propTypes = {
        propertyOptions: PropTypes.array.isRequired,
        activeCartProperty: PropTypes.any.isRequired,
        selectPropertyCallback: PropTypes.func.isRequired,
        canClearOnDoubleSelect: PropTypes.bool
    }

    static defaultProps = {
        placeHolder: ""
    }

    receiveCallbackTimeout = 0
    selectedBefore = false

    constructor(props) {

        super(props)

        this.state = this.getInitialStateObject(props)

    }

    /*
        componentDidMount() {
            if(this.state.defaultOption && !this.props.activeCartProperty) {
                this.props.selectPropertyCallback(this.state.defaultOption)
            }
        }*/

    getInitialStateObject = (props) => {

        let initialProperty = false
        let defaultOption = false

        // check if one of the software options is contained in cart
        props.propertyOptions.forEach((propertyOption) => {

            // set default if still empty
            if ((propertyOption.isDefault)) {
                defaultOption = propertyOption.value
                if (!initialProperty) {
                    initialProperty = propertyOption.value
                }
            }

            // set cart
            if ("" + props.activeCartProperty === ("" + propertyOption.value)) {
                initialProperty = propertyOption.value
            }
        })

        return {
            selectedProperty: initialProperty,
            defaultOption: defaultOption
        }

    }

    shouldComponentUpdate(nextProps, nextState) {

        if (this.receiveCallbackTimeout) {
            return false
        }

        return true

    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        let selectedProperty = false

        if (!this.receiveCallbackTimeout) {
            this.selectedBefore = this.state.selectedProperty
        }

        if (nextProps.propertyOptions.length !== this.props.propertyOptions.length) {

            if (this.state.selectedProperty !== this.state.defaultOption && this.state.defaultOption) {
                this.handleOptionDeSelect()
            }

            let nextState = this.getInitialStateObject(nextProps)

            this.setState(nextState)

            if (nextState.defaultOption) {
                if (this.receiveCallbackTimeout) {
                    clearTimeout(this.receiveCallbackTimeout)
                }
                this.receiveCallbackTimeout = setTimeout(() => {

                    let nextSelection = nextState.defaultOption

                    nextProps.propertyOptions.forEach(propertyOption => {
                        if (propertyOption.value === this.selectedBefore) {
                            nextSelection = this.selectedBefore
                        }
                    })

                    this.props.selectPropertyCallback(nextSelection).then(args => {
                        this.forceUpdate()
                        this.receiveCallbackTimeout = 0
                    })
                }, 350)
            }

            return
        }

        if (nextProps.activeCartProperty === this.props.activeCartProperty) {
            return
        }

        nextProps.propertyOptions.forEach((propertyOption) => {
            if ("" + nextProps.activeCartProperty === ("" + propertyOption.value)) {
                selectedProperty = propertyOption.value
            }
        })

        this.setState({
            selectedProperty: selectedProperty
        })

    }


    handleOptionSelect = (clickedOption) => {

        if (this.props.cartIsBusy) {
            return
        }

        const selectedProperty = this.state.selectedProperty

        if (selectedProperty !== clickedOption) {
            this.props.selectPropertyCallback(clickedOption)
            this.setState({
                selectedProperty: clickedOption
            })
        } else {

            if (clickedOption !== this.state.defaultOption && this.props.canClearOnDoubleSelect) {
                this.handleOptionDeSelect()
            }

        }
    }


    handleOptionDeSelect = (e) => {

        if (this.state.defaultOption) {
            this.setState({
                selectedProperty: this.state.defaultOption
            })
            this.props.selectPropertyCallback(this.state.defaultOption)
        } else {
            this.setState({
                selectedProperty: false
            })
            this.props.selectPropertyCallback(false)
        }

    }

    render() {

        return React.Children.only(
            this.props.children(
                this.handleOptionSelect,
                this.handleOptionDeSelect,
                this.state.defaultOption,
                this.state.selectedProperty
            )
        )

    }

}


export default CartPropertySelection


/** WEBPACK FOOTER **
 ** ./src/containers/configuration/CartPropertySelection.js
 **/